import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, withStyles } from '@material-ui/core';
import { Button } from '@orijinworks/frontend-commons';
import CloudSyncRoundedIcon from '@mui/icons-material/CloudSyncRounded';
import styles from './facility-lms-bulk-bar.style';

const FacilityLmsBulkBar = ({
  classes,
  selectedCount,
  eligibleOnPageCount,
  onProvisionSelected,
  onClearSelection,
  loading,
}) => {
  const hasSelection = selectedCount > 0;

  return (
    <Box
      className={classes.bar}
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      data-testid="facility-lms-bulk-bar"
    >
      {hasSelection ? (
        <>
          <Typography variant="body2" className={classes.summary}>
            {selectedCount} selected · {eligibleOnPageCount} eligible on this page
          </Typography>
          <Box className={classes.actions}>
            <Button
              color="primary"
              variant="contained"
              size="small"
              disabled={selectedCount === 0 || loading}
              onClick={onProvisionSelected}
              data-testid="facility-lms-bulk-provision-btn"
              startIcon={<CloudSyncRoundedIcon />}
            >
              Provision selected to Canvas
            </Button>
            <Box marginLeft={1}>
              <Button
                color="default"
                variant="outlined"
                size="small"
                disabled={loading}
                onClick={onClearSelection}
                data-testid="facility-lms-clear-selection-btn"
              >
                Clear selection
              </Button>
            </Box>
          </Box>
        </>
      ) : (
        <Typography variant="body2" className={classes.hint}>
          Select facilities with checkboxes to bulk-provision Canvas subaccounts.
          {eligibleOnPageCount > 0
            ? ` ${eligibleOnPageCount} on this page can be provisioned.`
            : ' No eligible facilities on this page.'}
          {' Header select-all applies to the current page only.'}
        </Typography>
      )}
    </Box>
  );
};

FacilityLmsBulkBar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  eligibleOnPageCount: PropTypes.number.isRequired,
  onProvisionSelected: PropTypes.func.isRequired,
  onClearSelection: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

FacilityLmsBulkBar.defaultProps = {
  loading: false,
};

export default withStyles(styles)(FacilityLmsBulkBar);
